import React from 'react';

export default function Bold_text({ text }) {
  return (
    <h2>{text}</h2>
  )
}
